<div class="container-fluid">

    <div class="row text-center pt-5">

      <div class="col-12">
        <h1>{{ 'common.thank_you_for_notification' | translate }}</h1>
      </div>

      <div class="col-12 mb-2" *ngIf="text">
        <span>{{ text }}</span>        

        <ng-container *ngIf="faultStatus && faultStatus === -1">
          <br />
          <small class="text-danger">{{ 'faultnotification.errors.file_upload_failure' | translate }}</small>
        </ng-container>
      </div>


      <div class="col-12 mb-2">
        <button class="btn btn-primary" (click)="goBack()">{{ 'common.actions.back' | translate }}</button>
      </div>

    </div>

</div>
